import { FC } from 'react';

const PrivacyPolicyPage: FC = () => {
  return (
    <div className="flex flex-col gap-6 max-w-full mx-auto w-[1280px] px-4 py-10">
      <h1 className="font-bold text-3xl">Privacy Policy</h1>

      <section className="flex flex-col gap-4">
        <p>
          For the purpose of the Data Protection Act 1998 (the Act), DMV Trading. as Operator of the Past Papers Plus
          website (www.pastpapersplus.com) "We" "us" and "our") of 84 Pauntley Road, Christchurch, Dorset, BH23 3JW, is
          a data controller. We are committed to protecting and respecting your privacy. This policy (together with our
          Website User Conditions) sets out the basis on which any personal data we collect from you, or that you
          provide to us, will be processed by us. Please read the following carefully.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Third party cookies – Google Analytics</h2>
        <p>
          This website uses Google Analytics, a web analytics service provided by Google, to allow us to evaluate and
          improve how the website is used. Google Analytics sets various cookies to collect standard internet log
          information and visitor behaviour information in an anonymous form. A cookie is a text-only string of
          information that a website transfers to the cookie file of the browser on your computer's hard disk so that
          the website can, among other things, remember who you are. The information generated by the cookie about your
          use of the website (including your IP address) is transmitted to Google. This information is then used to
          evaluate visitor's use of the website and to compile statistical reports on website activity. We do not use
          the statistical analytics tool to track or to collect any personally identifiable information of visitors to
          our site. Google will not associate your IP address with any other data held by Google. By using this website,
          you consent to the processing of data about your usage by Google in the manner and for the purposes set out
          above. Full information on how Google uses cookies can be found here:{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="link link-primary"
          >
            Google Privacy Policy
          </a>
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Other cookies</h2>
        <p>
          A cookie is a text-only string of information that a website transfers to the cookie file of the browser on
          your computer's hard disk so that the website can, among other things, remember who you are. This website
          makes use of a session cookie called ASP.NET_SessionID. This cookie contains no personally identifiable
          information and is necessary for website functionality. It is held temporarily in memory and deleted when the
          web browser is closed. We also use an additional cookie to store your wishlist only if you add items to the
          wishlist. Use of the website implies your consent to us placing these cookies on your computer.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">What information do we collect from you?</h2>
        <p>We may collect and process the following data about you from a variety of different sources including:</p>
        <ul className="list-disc list-inside pl-4 flex flex-col gap-2">
          <li>
            Information that you provide by filling in contact form or other information on this site
            www.pastpapersplus.com ("our site"). If you contact us, we may keep a record of that correspondence.
          </li>
          <li>
            We may also ask you to complete surveys that we use for research purposes, although you do not have to
            respond to them.
          </li>
          <li>Details of transactions you carry out or enquiries you make through or via our site.</li>
          <li>
            Details of your visits to our site including, but not limited to, traffic data, location data, weblogs and
            other communication data, whether this is required for our own billing purposes or otherwise and the
            information that you access.
          </li>
        </ul>
        <p>
          The information we collect may include (but may not be limited to) your name, address, email address and
          contact details including telephone numbers.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">IP addresses and cookies</h2>
        <p>
          We may collect information about your computer, including where available your IP address, operating system
          and browser type, for system administration and to report aggregate information to our advertisers. This is
          statistical data about our users' browsing actions and patterns and does not identify any individual.
        </p>
        <p>
          For the same reason, we may obtain information about your general internet usage by using a cookie file which
          is stored on the hard drive of your computer. Cookies contain information that is transferred to your
          computer's hard drive. They help us to improve our site and to deliver a better and more personalised service.
          They enable us:
        </p>
        <ul className="list-disc list-inside pl-4 flex flex-col gap-2">
          <li>To estimate our audience size and usage pattern.</li>
          <li>To store information about your preferences, and so allow us to customise our site according to your individual interests.</li>
          <li>To speed up your searches.</li>
          <li>To recognise you when you return to our site.</li>
        </ul>
        <p>
          You may refuse to accept cookies by activating the setting on your browser which allows you to refuse the
          setting of cookies. However, if you select this setting you may be unable to access certain parts of our site.
          Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies
          when you log on to our site. Please note that our advertisers may also use cookies, over which we have no
          control.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Where do we store your personal data?</h2>
        <p>
          All information you provide to us is stored on our secure servers. Any payment transactions will be encrypted
          using SSL technology. Where we have given you (or where you have chosen) a password which enables you to
          access certain parts of our site, you are responsible for keeping this password confidential. We ask you not
          to share a password with anyone.
        </p>
        <p>
          Unfortunately, the transmission of information via the internet is not completely secure. Although we will do
          our best to protect your personal data, we cannot guarantee the security of your data transmitted to our site;
          any transmission is at your own risk. Once we have received your information, we will use strict procedures
          and security features to try to prevent unauthorised access.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">What do we do with the information we collect?</h2>
        <p>We use information held about you in the following ways:</p>
        <ul className="list-disc list-inside pl-4 flex flex-col gap-2">
          <li>To ensure that content from our site is presented in the most effective manner for you and for your computer.</li>
          <li>
            To provide you with information or services that you request from us or which we feel may interest you,
            where you have consented to be contacted for such purposes.
          </li>
          <li>To carry out our obligations arising from any agreement made between you and us.</li>
          <li>To allow you to participate in interactive features of our service, when you choose to do so.</li>
          <li>To notify you about changes to our service.</li>
        </ul>
        <p>
          We may also use your data, or permit selected third parties to use your data, to provide you with information
          about goods and services which may be of interest to you and we or they may contact you about these.
        </p>
        <p>
          We may make use of the personal data we have collected from you to enable us to comply with our advertisers'
          wishes by displaying their advertisement to a particular target audience. We do not however disclose your
          personal data to our advertisers.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">When and how will we disclose your information</h2>
        <p>We may disclose your personal information to third parties:</p>
        <ul className="list-disc list-inside pl-4 flex flex-col gap-2">
          <li>
            In the event that we sell or buy any business or assets, in which case we may disclose your personal data to
            the prospective seller or buyer of such business or assets.
          </li>
          <li>
            If Past Papers Plus sells substantially all of its assets to a third party, personal data held by it about
            its customers will be one of the transferred assets.
          </li>
          <li>
            If we are under a duty to disclose or share your personal data in order to comply with any legal obligation,
            or in order to enforce or apply our Website User Conditions and other agreements; or to protect the rights,
            property, or safety of Past Papers Plus, our customers, or others. This includes exchanging information with
            other companies and organisations for the purposes of fraud protection and credit risk reduction.
          </li>
        </ul>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Your rights</h2>
        <p>
          You have the right to ask us not to process your personal data for marketing purposes. We will usually inform
          you (at the time of collecting your data) if we intend to use your data for such purposes or if we intend to
          disclose your information to any third party for such purposes. You can exercise your right to prevent such
          processing by checking certain boxes on the forms we use to collect your data. You can also exercise the right
          at any time by contacting us at the address referred to above at{' '}
          <a href="mailto:info@pastpapersplus.com" className="link link-primary">
            info@pastpapersplus.com
          </a>
        </p>
        <p>
          Our site may contain links to and from the websites of our partner networks or developers. If you follow a
          link to any of these websites, please note that these websites have their own privacy policies and that we do
          not accept any responsibility or liability for these policies. Please check these policies before you submit
          any personal data to these websites.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Access to information</h2>
        <p>
          The Act gives you the right to access information held about you. Your right of access can be exercised in
          accordance with the Act. Any access request may be subject to a fee of £10 to meet our costs in providing you
          with details of the information we hold about you. In certain circumstances we are entitled to refuse your
          request.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Changes to our privacy policy</h2>
        <p>Any changes we may make to our privacy policy in the future will be posted on this page.</p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Contact</h2>
        <p>
          Questions, comments and requests regarding this privacy policy are welcomed and should be addressed to{' '}
          <a href="mailto:info@pastpapersplus.com" className="link link-primary">
            info@pastpapersplus.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
